import {ItemQuantity} from '../models/warehouse-models';

export const manualAmountMl = (item: ItemQuantity, count: number): number | undefined => {
    if (item.trackingType !== 'LIQUID_ML') return undefined;
    if (count === 0) return 0;
    if (item.state === 'AVAILABLE' && item.oilCapacity != null)
        return Math.min(item.availableAmount ?? Infinity, item.oilCapacity * count);
    const physicalCount = item.physicalCount ?? item.count;
    return item.availableAmount != null && physicalCount > 0
        ? Math.round(item.availableAmount * count / physicalCount * 1000) / 1000 : undefined;
};

const stockDate = (item: ItemQuantity) => {
    for (const value of [item.deliveryDate, item.dateTime]) {
        const timestamp = value == null ? NaN : new Date(value).getTime();
        if (Number.isFinite(timestamp)) return timestamp;
    }
    return Infinity;
};

export const oldestStockFirst = (items: ItemQuantity[]) => [...items].sort((a, b) =>
    (stockDate(a) - stockDate(b) || (a.id ?? 0) - (b.id ?? 0)));

export const allocateManualCount = (items: ItemQuantity[], target: number): ItemQuantity[] => {
    let remaining = target;
    return oldestStockFirst(items).map(item => {
        const count = item.id == null ? 0 : Math.min(Math.max(item.count, 0), remaining);
        remaining -= count;
        return {...item, selectedCount: count || undefined};
    });
};

export const groupManualQuantities = (items: ItemQuantity[]) => {
    const groups = new Map<number, ItemQuantity[]>();
    items.forEach(item => {
        const id = item.passport.passportId;
        if (id == null) return;
        const group = groups.get(id);
        if (group) group.push(item);
        else groups.set(id, [item]);
    });
    return Array.from(groups, ([passportId, rows]) => ({passportId, rows: oldestStockFirst(rows)}));
};

export const sumManualAmountMl = (items: ItemQuantity[], selected = false): number | undefined => {
    let total = 0;
    for (const item of items) {
        const count = selected ? item.selectedCount ?? 0 : item.count;
        if (count === 0) continue;
        const amount = manualAmountMl(item, count);
        if (amount == null) return undefined;
        total += amount;
    }
    return Math.round(total * 1000) / 1000;
};
